import ApiConnector from "../apiConnector";
import { MonthlyApprovalItem } from "../entities/Approval/MonthlyApprovalItem";
import { AdminLock } from "../entities/AdminLock";

class AdminLockDataFetcher {
    private readonly apiConnector: ApiConnector;

    constructor(baseUrl: string){
        this.apiConnector = new ApiConnector(baseUrl);
    }

    public async updateAdminLock(locks: MonthlyApprovalItem[], actionAuthor: string){
        return await this.apiConnector.put<void>(`lock/admin/${actionAuthor}`, locks);
    }

    public async getAdminLock(userId: string, year: number, month: number): Promise<AdminLock> {
        return await this.apiConnector.get<AdminLock>(`lock/admin/${userId}/${year}/${month}`)
    }
}

export default AdminLockDataFetcher;